import { render, staticRenderFns } from "./Landing2Partners.vue?vue&type=template&id=572ba2c2&scoped=true"
import script from "./Landing2Partners.vue?vue&type=script&lang=js"
export * from "./Landing2Partners.vue?vue&type=script&lang=js"
import style0 from "./Landing2Partners.vue?vue&type=style&index=0&id=572ba2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ba2c2",
  null
  
)

export default component.exports